import { themeVars } from '@styles/themes.css';
import styled from 'styled-components';

export const MultiStepSubtitle = styled.p`
  font-family: ${themeVars.font.Roboto};
  font-size: 1rem !important;
  color: #717171 !important;
  width: 100%;
  margin: 0.25rem 0;
`;

export const MultiStepTitleWrapper = styled.div`
  width: 100%;
  margin: auto;
`;
